/* Ethetic Bundle Builder — theme asset. Aug 27: tiers 10/15/20 (badged EXTRA #% OFF), no free prints, 4+ expandable to 10 with BEST VALUE bar. Free US shipping over $100 (dynamic pill). Step 1 header: Build Your Bundle. Trust line under ATC (black): free US shipping over $100 + Made in USA. */
/* Sep 18 2026: PACK SELECTOR RESTORED, but only for products tagged `packs-on` (Custom Album first).
   cfg.packsEnabled comes from the section Liquid. Single / 2 Prints / 3+ Prints; 3+ expands to 10.
   Every other PDP still runs lockSinglePack() and renders exactly as it has since Sep 14. */
/* Sep 14 2026: PACK SELECTOR REMOVED. The builder is locked to the "single" pack, so the PDP renders
   exactly as it did when Single was selected — size, frame, price, ATC. The multi-pack code paths are
   left intact and unreachable; restore by deleting the lockSinglePack() call in connectedCallback and
   re-adding the Step 1 / .bb-packs block in render(). */
(function () {
  function normStr(s) { return String(s || '').toLowerCase().replace(/["\s]/g, ''); }
  function collsOf(p) { return Array.isArray(p.collections) ? p.collections : (p.collection ? [p.collection] : []); }
  var HIDDEN_COLLS = ['all', 'allposters', 'newarrivals', 'worldcup'];
  function visibleColl(t) { return t && HIDDEN_COLLS.indexOf(normStr(t)) === -1; }
  var DIM_RE = /(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)/;
  function dimArea(s) { var m = String(s || '').match(DIM_RE); return m ? parseFloat(m[1]) * parseFloat(m[2]) : null; }
  function dispSize(s) { return String(s || '').replace(/24\s*[xX×]\s*36/g, '24x32'); }
  var CM_MAP = { '12x16': '30x40cm', '18x24': '45x60cm', '24x32': '60x80cm' };
  var POPULAR_SIZE = '18x24';
  function sizeKey(s) {
    var m = String(s || '').match(DIM_RE);
    return m ? (parseInt(m[1], 10) + 'x' + parseInt(m[2], 10)) : '';
  }
  function dispSizeCm(s) {
    var d = dispSize(s);
    var cm = CM_MAP[sizeKey(d)];
    if (!cm) return d;
    return d + ' <span style="color:#8a8781;font-weight:400;font-size:12px">(' + cm + ')</span>';
  }
  function dispSizeCmText(s) {
    var d = dispSize(s);
    var cm = CM_MAP[sizeKey(d)];
    if (!cm) return d;
    return d + ' (' + cm + ')';
  }
  function popBadge(s) {
    return sizeKey(dispSize(s)) === POPULAR_SIZE ? ' <span style="background:#111;color:#fff;font-size:9px;font-weight:800;padding:2px 6px;border-radius:3px;letter-spacing:.04em;white-space:nowrap;vertical-align:middle">MOST POPULAR</span>' : '';
  }
  var SLIDER_COLLS = [
    { label: 'Motivation', keys: ['motivation'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Motivation_0afe2aac-81ca-48cc-95f0-28e9cbee4ae5.png?v=1787284229' },
    { label: 'Lifestyle', keys: ['lifestyle'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Lifestyle_5d0a602f-f80f-4bdc-92ee-fe7d6483e973.png?v=1787284230' },
    { label: 'Music', keys: ['music'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Music_81c5b547-25c5-4ffd-b18a-5b007f2b166f.jpg?v=1787284229' },
    { label: 'Bible Verse', keys: ['bibleverse', 'bible'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Bible_4a098840-d2d3-428e-a163-fe077c9809a5.png?v=1787284229' },
    { label: 'Formula 1', keys: ['formula1', 'f1'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/F1.png?v=1787284283' },
    { label: 'Dictionary', keys: ['dictionary'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Dictionary_a5bc6d54-b16e-4e59-b82d-39069738a2c.png?v=1787284229' },
    { label: 'Automotive', keys: ['automotive', 'auto'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Automotive_ecfbaf91-7269-4f28-aeeb-dcab7a479e69.jpg?v=1787284228' },
    { label: 'Sports', keys: ['sports', 'sport'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Sports_2e74fb75-326b-41b4-b4cf-31d51b73572f.png?v=1787284229' },
    { label: 'City', keys: ['city', 'cities'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/City_63193522-e8fb-423e-ab18-1f3af26da1a1.jpg?v=1787284874' }
  ];
  var CUSTOM_FIELDS = [
    { match: 'album', fields: ['Album Name', 'Artist Name'] },
    { match: 'dictionary', fields: ['Word', 'Definition'] },
    { match: 'city', fields: ['City Name', 'Country Name'], img: true },
    { match: 'car', fields: ['Car Name'], img: true }
  ];
  var CUSTOM_FALLBACK = { fields: ['Personalization'] };
  function isCustom(p) { return p && /custom/i.test(p.title || ''); }
  function customEntryFor(p) {
    if (!isCustom(p)) return null;
    var t = normStr(p.title);
    for (var i = 0; i < CUSTOM_FIELDS.length; i++) {
      if (t.includes(CUSTOM_FIELDS[i].match)) return CUSTOM_FIELDS[i];
    }
    return CUSTOM_FALLBACK;
  }
  function customFieldsFor(p) { var e = customEntryFor(p); return e ? e.fields : null; }
  function customImgFor(p) { var e = customEntryFor(p); return !!(e && e.img); }
  function resolveValue(want, list) {
    if (!want || !Array.isArray(list)) return null;
    return list.find(v => v === want)
      || list.find(v => normStr(v).startsWith(normStr(want)))
      || list.find(v => normStr(v).includes(normStr(want)))
      || null;
  }
  function shiftKeys(obj, prefix, removedIdx) {
    var out = {};
    Object.keys(obj).forEach(function (k) {
      var parts = k.split(':');
      if (parts[0] !== prefix) { out[k] = obj[k]; return; }
      var i = +parts[1];
      if (i === removedIdx) return;
      out[prefix + ':' + (i > removedIdx ? i - 1 : i)] = obj[k];
    });
    return out;
  }
  function centerH(container, el) {
    if (!container || !el) return;
    container.scrollLeft = Math.max(0, el.offsetLeft - (container.clientWidth - el.offsetWidth) / 2);
  }
  function visibleOverlays() {
    var out = [];
    var els = document.body.querySelectorAll('div,aside,section,dialog,iframe');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var st = window.getComputedStyle(el);
      if (st.position !== 'fixed' && st.position !== 'absolute') continue;
      if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity || '1') < 0.05) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 120 || r.height < window.innerHeight * 0.3) continue;
      if (r.right < 0 || r.left > window.innerWidth) continue;
      out.push(el);
    }
    return out;
  }
  function openCartDrawer(fallbackUrl) {
    var kc = window.kachingCartApi;
    if (kc && typeof kc.openCart === 'function') {
      try { if (typeof kc.refreshCart === 'function') kc.refreshCart(); } catch (e) {}
      try { kc.openCart(); return; } catch (e) {}
    }
    var before = visibleOverlays();
    try { if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function') { Shopify.actions.openCart(); } } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('shopify:cart:change', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    } catch (e) {}
    var candidates = ['a[href="/cart"]', 'a[href^="/cart?"]', '[data-cart-drawer-toggle]', '[data-drawer-toggle="cart"]', '.cart-icon', '#cart-icon-bubble', '[aria-controls*="cart" i]'];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) {
        try { el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); } catch (e) {}
        break;
      }
    }
    function newOverlayAppeared() {
      var now = visibleOverlays();
      for (var j = 0; j < now.length; j++) {
        if (before.indexOf(now[j]) === -1) return true;
      }
      return false;
    }
    var checks = 0;
    var timer = setInterval(function () {
      checks++;
      if (newOverlayAppeared()) { clearInterval(timer); return; }
      if (checks >= 6) { clearInterval(timer); window.location.href = fallbackUrl; }
    }, 250);
  }
  /* Sep 14 2026 — pack selector removed. Keep only the single-print pack so every code path below
     that branches on pack.paid > 1 stays on the single branch. */
  /* Coupon-ticket tier strip. Kept in a stylesheet rather than inline styles because the notch
     needs mask-composite and the dividers need an adjacent-sibling selector. */
  var TIER_STYLE_ID = 'bb-tier-style';
  var TIER_CSS = [
    /* 10px side padding keeps the columns clear of the 7px notch, which sits at mid-height on both
       edges - at 5px the outer "Extra nn% off" lines were being clipped by it */
    '.bb-ticket{display:flex;align-items:stretch;background:#111;color:#fff;border-radius:5px;padding:0 10px;',
      '-webkit-mask-image:radial-gradient(circle 7px at 0 50%,transparent 98%,#000 100%),radial-gradient(circle 7px at 100% 50%,transparent 98%,#000 100%);',
      'mask-image:radial-gradient(circle 7px at 0 50%,transparent 98%,#000 100%),radial-gradient(circle 7px at 100% 50%,transparent 98%,#000 100%);',
      '-webkit-mask-composite:source-in;mask-composite:intersect}',
    '.bb-ticket-col{flex:1;text-align:center;padding:8px 4px 9px}',
    '.bb-ticket-col+.bb-ticket-col{border-left:1px dashed rgba(255,255,255,.4)}',
    '.bb-ticket-q{display:block;font-weight:800;letter-spacing:-.005em;white-space:nowrap;color:#fff;font-size:clamp(11.5px,3.45vw,14px)}',
    '.bb-ticket-o{display:block;font-weight:700;letter-spacing:-.005em;margin-top:2px;white-space:nowrap;color:#fff;font-size:clamp(10.5px,3.1vw,13.5px)}',
    '.bb-tiers-note{text-align:center;font-size:10.5px;line-height:1.5;letter-spacing:.01em;color:#96938d;margin-top:8px}',
    '.bb-shipbar{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:3px 14px;background:#f2f1ee;border-radius:8px;padding:9px 14px;margin:14px 0 0;font-size:12px;line-height:1.45;color:#4a4842}',
    '.bb-shipbar-i{display:inline-flex;align-items:center;gap:7px;white-space:nowrap}',
    '.bb-shipbar strong{font-weight:800;color:#111}',
    '.bb-dot{width:8px;height:8px;border-radius:50%;background:#22c55e;flex:0 0 auto;',
      'box-shadow:0 0 0 0 rgba(34,197,94,.6);animation:bb-pulse 2s ease-out infinite}',
    '@keyframes bb-pulse{0%{box-shadow:0 0 0 0 rgba(34,197,94,.6)}70%{box-shadow:0 0 0 7px rgba(34,197,94,0)}100%{box-shadow:0 0 0 0 rgba(34,197,94,0)}}',
    '@media(prefers-reduced-motion:reduce){.bb-dot{animation:none;box-shadow:0 0 6px 1px rgba(34,197,94,.75)}}',
    '.bb-flag{font-size:13px;line-height:1}',
    /* stays space-between at every width so Order now sits hard left and Fast Shipping hard right */
    '@media(max-width:430px){.bb-shipbar{gap:2px 10px;font-size:11.5px;padding:8px 11px}}',
    /* SIZE KNOBS for the badges under the ATC. The theme editor cannot reach these - the badges are
       rendered by trustHTML() in this file, not by the ss_trust_badges section. Change them here. */
    '.bb-trust{display:flex;align-items:flex-start;gap:8px;margin-top:16px}',
    '.bb-trust-i{flex:1;display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px}',
    '.bb-trust-i svg{width:30px;height:30px;color:#111;display:block;flex:0 0 auto}',
    '.bb-trust-l{font-size:11.5px;font-weight:800;line-height:1.3;letter-spacing:-.005em;color:#111}',
    '@media(max-width:430px){.bb-trust{gap:6px;margin-top:14px}.bb-trust-i{gap:7px}.bb-trust-i svg{width:26px;height:26px}.bb-trust-l{font-size:10.5px}}'
  ].join('');
  function injectTierStyles() {
    if (document.getElementById(TIER_STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = TIER_STYLE_ID;
    el.textContent = TIER_CSS;
    document.head.appendChild(el);
  }
  /* Ship-by badge. Artelo production is 2-3 business days (ethetic/site/shipping-promise.md, verified
     7 Sep 2026 against artelo.com/shipping). Marlon's call 15 Sep 2026: quote the FAST end (2) rather
     than the slow end (3). Weekends skipped; public holidays are not. */
  var SHIP_BUSINESS_DAYS = 2;
  function shipByDate() {
    var d = new Date(), added = 0;
    while (added < SHIP_BUSINESS_DAYS) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function shipByLabel() {
    try {
      return new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' }).format(shipByDate());
    } catch (e) { return null; }
  }
  /* Shopify assigns the market by geo-IP on first visit and exposes it as Shopify.country, so this
     follows the visitor's session rather than a hardcoded locale. */
  function sessionCountry() {
    try { if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase(); } catch (e) {}
    var inp = document.querySelector('form[action*="/localization"] input[name="country_code"]');
    if (inp && inp.value) return String(inp.value).toUpperCase();
    return 'US';
  }
  function flagOf(cc) {
    if (!/^[A-Z]{2}$/.test(cc)) return '';
    try {
      return String.fromCodePoint(0x1F1E6 + cc.charCodeAt(0) - 65, 0x1F1E6 + cc.charCodeAt(1) - 65);
    } catch (e) { return ''; }
  }
  var TRUST_ICONS = ["<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" fill=\"currentColor\" > <path d=\"M 0 8 L 0 10 L 28.09375 10 C 28.492188 10 29 10.507813 29 10.90625 L 29 38 L 18.90625 38 C 18.429688 35.164063 15.964844 33 13 33 C 10.035156 33 7.570313 35.164063 7.09375 38 L 3 38 C 2.445313 38 2 37.554688 2 37 L 2 28 L 0 28 L 0 37 C 0 38.644531 1.355469 40 3 40 L 7.09375 40 C 7.570313 42.835938 10.035156 45 13 45 C 15.964844 45 18.429688 42.835938 18.90625 40 L 34.09375 40 C 34.570313 42.835938 37.035156 45 40 45 C 42.964844 45 45.429688 42.835938 45.90625 40 L 47 40 C 47.832031 40 48.5625 39.625 49.09375 39.09375 C 49.625 38.5625 50 37.832031 50 37 L 50 27.40625 C 50 26.28125 49.570313 25.25 49.1875 24.46875 C 48.804688 23.6875 48.40625 23.125 48.40625 23.125 L 48.40625 23.09375 L 44.3125 17.59375 L 44.28125 17.59375 L 44.28125 17.5625 C 43.394531 16.453125 41.972656 15 40 15 L 32 15 C 31.640625 15 31.3125 15.066406 31 15.1875 L 31 10.90625 C 31 9.304688 29.695313 8 28.09375 8 Z M 0 12 L 0 14 L 18 14 L 18 12 Z M 0 16 L 0 18 L 15 18 L 15 16 Z M 32 17 L 36 17 L 36 26 C 36 26.832031 36.375 27.5625 36.90625 28.09375 C 37.4375 28.625 38.167969 29 39 29 L 48 29 L 48 37 C 48 37.167969 47.875 37.4375 47.65625 37.65625 C 47.4375 37.875 47.167969 38 47 38 L 45.90625 38 C 45.429688 35.164063 42.964844 33 40 33 C 37.035156 33 34.570313 35.164063 34.09375 38 L 31 38 L 31 18 C 31 17.832031 31.125 17.5625 31.34375 17.34375 C 31.5625 17.125 31.832031 17 32 17 Z M 38 17 L 40 17 C 40.824219 17 41.972656 17.925781 42.6875 18.8125 L 46.78125 24.28125 L 46.8125 24.3125 C 46.832031 24.339844 47.101563 24.722656 47.40625 25.34375 C 47.660156 25.859375 47.792969 26.472656 47.875 27 L 39 27 C 38.832031 27 38.5625 26.875 38.34375 26.65625 C 38.125 26.4375 38 26.167969 38 26 Z M 0 20 L 0 22 L 12 22 L 12 20 Z M 0 24 L 0 26 L 9 26 L 9 24 Z M 13 35 C 15.222656 35 17 36.777344 17 39 C 17 41.222656 15.222656 43 13 43 C 10.777344 43 9 41.222656 9 39 C 9 36.777344 10.777344 35 13 35 Z M 40 35 C 42.222656 35 44 36.777344 44 39 C 44 41.222656 42.222656 43 40 43 C 37.777344 43 36 41.222656 36 39 C 36 36.777344 37.777344 35 40 35 Z\"/> </svg>", "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" fill=\"currentColor\" > <path d=\"M 15 7 C 7.832031 7 2 12.832031 2 20 C 2 34.761719 18.695313 42.046875 24.375 46.78125 L 25 47.3125 L 25.625 46.78125 C 31.304688 42.046875 48 34.761719 48 20 C 48 12.832031 42.167969 7 35 7 C 30.945313 7 27.382813 8.925781 25 11.84375 C 22.617188 8.925781 19.054688 7 15 7 Z M 15 9 C 18.835938 9 22.1875 10.96875 24.15625 13.9375 L 25 15.1875 L 25.84375 13.9375 C 27.8125 10.96875 31.164063 9 35 9 C 41.085938 9 46 13.914063 46 20 C 46 32.898438 31.59375 39.574219 25 44.78125 C 18.40625 39.574219 4 32.898438 4 20 C 4 13.914063 8.914063 9 15 9 Z\"/> </svg>", "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" fill=\"currentColor\" > <path d=\"M 25 1.9199219 C 12.265113 1.9199219 1.9199219 12.265113 1.9199219 25 C 1.9199219 37.734887 12.265113 48.080078 25 48.080078 C 37.734887 48.080078 48.080078 37.734887 48.080078 25 C 48.080078 12.265113 37.734887 1.9199219 25 1.9199219 z M 24 4.0371094 L 24 13.970703 C 21.43251 13.91011 18.991445 13.623022 16.740234 13.152344 C 17.136627 11.9515 17.587103 10.835559 18.087891 9.8339844 C 19.740825 6.5281156 21.837286 4.5160498 24 4.0371094 z M 26 4.0371094 C 28.162714 4.5160498 30.259175 6.5281156 31.912109 9.8339844 C 32.414496 10.838757 32.866379 11.958806 33.263672 13.164062 C 31.015269 13.630037 28.5709 13.911377 26 13.970703 L 26 4.0371094 z M 19.171875 4.7402344 C 18.086481 5.8772845 17.118637 7.2998344 16.298828 8.9394531 C 15.727502 10.082106 15.226366 11.34271 14.789062 12.6875 C 12.825936 12.158279 11.050587 11.492361 9.5175781 10.71875 C 12.097501 7.9227151 15.411073 5.8180109 19.171875 4.7402344 z M 30.828125 4.7402344 C 34.585289 5.8169681 37.895737 7.9189636 40.474609 10.710938 C 38.96425 11.498668 37.190868 12.172098 35.216797 12.703125 C 34.778353 11.352409 34.274712 10.086534 33.701172 8.9394531 C 32.881363 7.2998344 31.913519 5.8772845 30.828125 4.7402344 z M 41.783203 12.273438 C 44.280319 15.563254 45.849591 19.596544 46.054688 24 L 37.013672 24 C 36.940686 20.642697 36.511581 17.472843 35.777344 14.632812 C 38.021162 14.025788 40.043564 13.230357 41.783203 12.273438 z M 8.2050781 12.289062 C 9.9635362 13.222752 11.989301 14.00879 14.226562 14.615234 C 13.489633 17.459671 13.059462 20.635904 12.986328 24 L 3.9453125 24 C 4.1500856 19.603485 5.7148727 15.576078 8.2050781 12.289062 z M 16.175781 15.085938 C 18.608124 15.603479 21.237145 15.911692 24 15.972656 L 24 24 L 14.986328 24 C 15.060725 20.787369 15.480743 17.762271 16.175781 15.085938 z M 33.828125 15.099609 C 34.521088 17.7726 34.939401 20.792796 35.013672 24 L 26 24 L 26 15.972656 C 28.764457 15.913393 31.396477 15.612271 33.828125 15.099609 z M 3.9453125 26 L 12.986328 26 C 13.059314 29.357303 13.488419 32.527156 14.222656 35.367188 C 11.978838 35.974212 9.9564363 36.769643 8.2167969 37.726562 C 5.7196806 34.436746 4.1504088 30.403456 3.9453125 26 z M 14.986328 26 L 24 26 L 24 34.027344 C 21.235543 34.086607 18.603523 34.387729 16.171875 34.900391 C 15.478912 32.2274 15.060599 29.207204 14.986328 26 z M 26 26 L 35.013672 26 C 34.939275 29.212631 34.519257 32.237729 33.824219 34.914062 C 31.391876 34.396521 28.762855 34.088308 26 34.027344 L 26 26 z M 37.013672 26 L 46.054688 26 C 45.849914 30.396515 44.285127 34.423922 41.794922 37.710938 C 40.036464 36.777248 38.010699 35.99121 35.773438 35.384766 C 36.510367 32.540329 36.940538 29.364096 37.013672 26 z M 24 36.029297 L 24 45.962891 C 21.837286 45.48395 19.740825 43.471884 18.087891 40.166016 C 17.585504 39.161243 17.133621 38.041194 16.736328 36.835938 C 18.984731 36.369963 21.4291 36.088623 24 36.029297 z M 26 36.029297 C 28.56749 36.08989 31.008555 36.376978 33.259766 36.847656 C 32.863373 38.0485 32.412897 39.16444 31.912109 40.166016 C 30.259175 43.471884 28.162714 45.48395 26 45.962891 L 26 36.029297 z M 14.783203 37.296875 C 15.221647 38.647591 15.725288 39.913466 16.298828 41.060547 C 17.118637 42.700166 18.086481 44.122716 19.171875 45.259766 C 15.414711 44.183032 12.104263 42.081036 9.5253906 39.289062 C 11.03575 38.501332 12.809132 37.827902 14.783203 37.296875 z M 35.210938 37.3125 C 37.174064 37.841721 38.949413 38.507639 40.482422 39.28125 C 37.902499 42.077285 34.588927 44.181989 30.828125 45.259766 C 31.913519 44.122716 32.881363 42.700166 33.701172 41.060547 C 34.272498 39.917894 34.773634 38.65729 35.210938 37.3125 z\"/> </svg>"];
  function lockSinglePack(cfg) {
    var all = (cfg.packs || []).slice();
    var single = all.find(function (p) { return p && p.paid === 1; }) || all[0];
    if (!single) throw new Error('no single-print pack defined');
    /* Kept for the static tier strip under the ATC. Mirrors the live Shopify automatic discounts
       "Pack Discount (SAVE 10/15/20%)", which are keyed to cart quantity >= 2/3/4 and apply
       regardless of how the cart was assembled. */
    cfg.tierPacks = all.filter(function (p) { return p && p.paid > 1 && p.off > 0; });
    single.off = 0;
    single.expandable = false;
    single.best = false;
    cfg.packs = [single];
    return single;
  }
  /* Sep 18 2026. The coupon tier strip is suppressed when the selector is on — the pack buttons
     carry the same offer and showing both states it twice. The 4-pack is dropped; the 3-pack
     becomes the expandable one, so "3+" grows to 10 via the existing addMore path. */
  /* Which products get the selector. cfg.packsEnabled (set by the section Liquid from a `packs-on`
     product tag) wins whenever it is present; this id list is the fallback so the selector can ship
     without a Liquid change. Add an id here, or add the tag once the Liquid carries packsEnabled. */
  var PACKS_ON_IDS = [8886335013175]; /* Custom Album */
  function packsOn(cfg) {
    if (typeof cfg.packsEnabled === 'boolean') return cfg.packsEnabled;
    var cp = cfg.currentProduct;
    return !!(cp && PACKS_ON_IDS.indexOf(cp.id) !== -1);
  }
  function enablePacks(cfg) {
    var src = (cfg.packs || []).slice();
    /* The real ladder is the live Shopify automatic Pack Discounts, keyed to CART QUANTITY
       (>=2 10%, >=3 15%, >=4 20%). The 3+ pack expands past 4, so the displayed discount has to
       follow the slot count, not the pack — see offNow(). */
    cfg.qtyTiers = src.filter(function (p) { return p && p.paid > 1 && p.off > 0; })
      .map(function (p) { return { min: p.paid, off: p.off }; })
      .sort(function (a, b) { return a.min - b.min; });
    var all = src.filter(function (p) { return p && p.paid <= 3; });
    var single = all.find(function (p) { return p.paid === 1; });
    var two = all.find(function (p) { return p.paid === 2; });
    var three = all.find(function (p) { return p.paid === 3; });
    if (!single) throw new Error('no single-print pack defined');
    single.off = 0; single.expandable = false; single.best = false; single.label = 'Single';
    if (two) { two.expandable = false; two.best = false; two.label = '2 Prints'; }
    if (three) { three.expandable = true; three.best = true; three.label = '3+ Prints'; }
    cfg.tierPacks = [];
    cfg.packs = all;
    return single;
  }
  class EtheticBundleBuilder extends HTMLElement {
    connectedCallback() {
      try {
        const dataEl = this.querySelector('script[type="application/json"]');
        if (!dataEl) throw new Error('config script tag missing');
        this.cfg = JSON.parse(dataEl.textContent);
        if (!Array.isArray(this.cfg.sizes) || !this.cfg.sizes.length) throw new Error('no size option detected on this product');
        if (!Array.isArray(this.cfg.frames) || !this.cfg.frames.length) throw new Error('no frame option detected on this product');
        this.cfg.packsEnabled = packsOn(this.cfg);
        const singlePack = this.cfg.packsEnabled ? enablePacks(this.cfg) : lockSinglePack(this.cfg);
        const seen = {};
        this.cfg.catalog = (this.cfg.catalog || []).filter(p => { if (!p || seen[p.id]) return false; seen[p.id] = 1; return true; });
        const unf = this.cfg.frames.filter(f => /unfram/i.test(f));
        const blk = this.cfg.frames.filter(f => !/unfram/i.test(f) && /black/i.test(f));
        const rest = this.cfg.frames.filter(f => !/unfram/i.test(f) && !/black/i.test(f));
        this.cfg.frames = unf.concat(blk, rest);
        this.sizeTiers = this.cfg.sizes.slice().sort(function (a, b) { return (dimArea(a) || 0) - (dimArea(b) || 0); });
        this._sizeCache = {};
        const defSize = resolveValue(this.cfg.defaultSize, this.cfg.sizes);
        const defFrame = resolveValue(this.cfg.defaultFrame, this.cfg.frames);
        const collList = [];
        const collImg = {};
        this.cfg.catalog.forEach(p => collsOf(p).forEach(t => {
          if (!visibleColl(t)) return;
          if (collList.indexOf(t) === -1) collList.push(t);
          if (!collImg[t] && p.image) collImg[t] = p.image;
        }));
        this.collList = collList;
        this.collImg = collImg;
        this.sliderColls = SLIDER_COLLS.map(e => {
          const t = collList.find(ct => e.keys.some(k => normStr(ct).includes(k)));
          return t ? { label: e.label, title: t, img: e.img || collImg[t] || null } : null;
        }).filter(Boolean);
        const defColl = collList.find(t => /best/i.test(t)) || collList[0] || null;
        this.state = {
          pack: singlePack,
          sizeValue: defSize || this.cfg.sizes[0],
          frameValue: defFrame || this.cfg.frames[0],
          paid: [], custom: {}, customFile: {}, sizeBy: {}, frameBy: {}, pickTarget: null, filter: defColl, busy: false, sizeOpenKey: null
        };
        if (this.cfg.currentProduct) this.state.paid = [this.cfg.currentProduct];
        this.setPack(this.state.pack);
      } catch (e) {
        console.error('[bundle-builder]', e);
        const root = this.querySelector('[data-bb-root]');
        if (root) root.innerHTML = '<div class="bb-error">Bundle builder failed to load: ' + (e && e.message ? e.message : 'unknown error') + '</div>';
      }
    }
    disconnectedCallback() { if (this._portal) { this._portal.remove(); this._portal = null; } }
    fmt(cents) { return '$' + (cents / 100).toFixed(2); }
    frameImg(f) {
      const fi = this.cfg.frameImages || {};
      const key = Object.keys(fi).find(k => normStr(f).includes(k));
      return key && fi[key] ? fi[key] : null;
    }
    sizesOf(product) {
      if (!product) return [];
      const cached = this._sizeCache[product.id];
      if (cached) return cached;
      const vals = [];
      (product.variants || []).forEach(v => (v.options || []).forEach(o => {
        if (dimArea(o) != null && vals.indexOf(o) === -1) vals.push(o);
      }));
      vals.sort(function (a, b) { return dimArea(a) - dimArea(b); });
      this._sizeCache[product.id] = vals;
      return vals;
    }
    sizeFor(product, want) {
      if (!product || !want) return want;
      const exact = (product.variants || []).some(v => (v.options || []).some(o => normStr(o) === normStr(want)));
      if (exact) return want;
      const own = this.sizesOf(product);
      if (!own.length) return want;
      let idx = this.sizeTiers.findIndex(t => normStr(t) === normStr(want));
      if (idx === -1) {
        const wa = dimArea(want);
        idx = 0;
        if (wa != null) {
          let best = Infinity;
          this.sizeTiers.forEach((t, i) => { const d = Math.abs((dimArea(t) || 0) - wa); if (d < best) { best = d; idx = i; } });
        }
      }
      const ratio = this.sizeTiers.length > 1 ? idx / (this.sizeTiers.length - 1) : 0;
      const ownIdx = Math.round(ratio * (own.length - 1));
      return own[Math.max(0, Math.min(own.length - 1, ownIdx))];
    }
    sizeAt(i){ return this.state.sizeBy["paid:"+i] || this.state.sizeValue }
    frameAt(i){ return this.state.frameBy["paid:"+i] || this.state.frameValue }
    findVariant(product, sizeV, frameV) {
      if (!product) return null;
      const rs = this.sizeFor(product, sizeV);
      return product.variants.find(v =>
        v.options.some(o => normStr(o) === normStr(rs)) &&
        v.options.some(o => normStr(o) === normStr(frameV))
      ) || null;
    }
    priceOf(product, sizeV, frameV) {
      const v = this.findVariant(product, sizeV, frameV);
      return v ? v.price : null;
    }
    compareOf(product, sizeV, frameV) {
      const v = this.findVariant(product, sizeV, frameV);
      if (!v) return null;
      return (v.compare_at && v.compare_at > v.price) ? v.compare_at : v.price;
    }
    refProduct() { return this.state.paid[0] || this.cfg.currentProduct || null; }
    slotProduct(key) {
      const parts = key.split(':');
      return this.state.paid[+parts[1]];
    }
    customSlots() {
      const s = this.state, out = [];
      s.paid.forEach((p, i) => { if (isCustom(p)) out.push({ key: 'paid:' + i, product: p, fields: customFieldsFor(p) }); });
      return out;
    }
    customOk() {
      const s = this.state;
      return this.customSlots().every(cs => cs.fields.every(f => ((s.custom[cs.key] || {})[f] || '').trim().length > 0));
    }
    setPack(pack) {
      const s = this.state;
      if (pack.paid === 1) { if (s.sizeBy['paid:0']) s.sizeValue = s.sizeBy['paid:0']; s.sizeBy = {}; if (s.frameBy['paid:0']) s.frameValue = s.frameBy['paid:0']; s.frameBy = {}; }
      s.pack = pack;
      s.paid = s.paid.slice(0, pack.paid); while (s.paid.length < pack.paid) s.paid.push(null);
      /* Sep 18 2026: on a packs-on product every slot is THIS product — a 3-pack of Custom Album is
         three albums, not a trip to the catalogue picker. Slots stay pickable if they want another. */
      if (this.cfg.packsEnabled && this.cfg.currentProduct) {
        for (var _i = 0; _i < s.paid.length; _i++) if (!s.paid[_i]) s.paid[_i] = this.cfg.currentProduct;
      }
      if (!s.paid[0] && this.cfg.currentProduct) s.paid[0] = this.cfg.currentProduct;
      this.render();
    }
    paidCount() { return this.state.paid.length; }
    /* Discount actually in force for the current slot count. With the selector off there are no
       qtyTiers, so this returns pack.off (0) and nothing changes. */
    offNow() {
      var n = this.state.paid.length, tiers = this.cfg.qtyTiers || [], off = this.state.pack.off || 0;
      for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].min) off = tiers[i].off;
      return off;
    }
    totals() {
      const s = this.state; let list = 0, pay = 0, ok = true;
      s.paid.forEach((p, i) => {
        if (!p) { ok = false; return; }
        const pr = this.priceOf(p, this.sizeAt(i), this.frameAt(i));
        const cmp = this.compareOf(p, this.sizeAt(i), this.frameAt(i));
        if (pr == null) { ok = false; return; }
        list += cmp; pay += Math.round(pr * (1 - this.offNow()));
      });
      return { list, pay, saving: list - pay, ok };
    }
    itemDescriptors() {
      const s = this.state, out = [];
      s.paid.forEach((p, i) => {
        const v = this.findVariant(p, this.sizeAt(i), this.frameAt(i));
        if (!v) return;
        const key = 'paid:' + i;
        const props = { _pack: '', _pack_size: s.pack.label + (s.pack.expandable ? ' (' + s.paid.length + ')' : '') };
        const cv = s.custom[key];
        if (isCustom(p) && cv) Object.keys(cv).forEach(k => { if ((cv[k] || '').trim()) props[k] = cv[k].trim(); });
        out.push({ id: v.id, props: props, fileKey: key });
      });
      return out;
    }
    async addToCart() {
      const s = this.state; if (s.busy) return; s.busy = true; this.render();
      const packId = 'pack_' + Date.now();
      const descriptors = this.itemDescriptors();
      descriptors.forEach(d => { d.props._pack = packId; });
      const anyFile = descriptors.some(d => s.customFile[d.fileKey]);
      try {
        if (!anyFile) {
          const items = descriptors.map(d => ({ id: d.id, quantity: 1, properties: d.props }));
          const r = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!r.ok) throw new Error(await r.text());
        } else {
          for (let i = 0; i < descriptors.length; i++) {
            const d = descriptors[i];
            const fd = new FormData();
            fd.append('id', d.id);
            fd.append('quantity', '1');
            Object.keys(d.props).forEach(k => fd.append('properties[' + k + ']', d.props[k]));
            const f = s.customFile[d.fileKey];
            if (f) fd.append('properties[Custom Image]', f, f.name);
            const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
            if (!r.ok) throw new Error(await r.text());
          }
        }
        s.busy = false; this.render();
        openCartDrawer('/cart');
      } catch (e) {
        console.error('[bundle-builder] add-to-cart', e);
        s.busy = false; this.render();
        alert('Could not add pack to cart. Please try again.');
      }
    }
    tiersHTML() {
      /* TIER_CSS also styles the ship bar and the trust badges, so the inject must happen even when
         there is no coupon strip to draw — suppressing the strip must not unstyle the rest.
         (Broke exactly this way on 18 Sep when enablePacks() zeroed tierPacks.) */
      injectTierStyles();
      const tiers = this.cfg.tierPacks || [];
      if (!tiers.length) return '';
      const cols = tiers.map((p) => {
        const qty = 'Buy ' + p.paid + (p.expandable ? '+' : '');
        const off = 'Extra ' + Math.round(p.off * 100) + '% OFF';
        return `<div class="bb-ticket-col">
          <span class="bb-ticket-q">${qty}</span>
          <span class="bb-ticket-o">${off}</span>
        </div>`;
      }).join('');
      return `<div class="bb-tiers" style="margin:15px 0 16px">
        <div class="bb-ticket">${cols}</div>
        <div class="bb-tiers-note">Mix any designs and any sizes. Applied automatically at checkout.</div>
      </div>`;
    }
    shipBarHTML() {
      const label = shipByLabel();
      if (!label) return '';
      const cc = sessionCountry();
      const flag = flagOf(cc);
      return `<div class="bb-shipbar">
        <span class="bb-shipbar-i"><span class="bb-dot"></span><span>Ships by <strong>${label}</strong></span></span>
        <span class="bb-shipbar-i">${flag ? `<span class="bb-flag">${flag}</span>` : ''}<span><strong>Fast</strong> Shipping</span></span>
      </div>`;
    }
    atcHTML() {
      const s = this.state, t = this.totals(), cok = this.customOk();
      const dis = !t.ok || !cok || s.busy;
      let label;
      if (s.busy) label = 'Adding…';
      else if (!t.ok) label = 'Fill all slots to continue';
      else if (!cok) label = 'Enter personalization to continue';
      else label = `Add to Cart — ${t.saving > 0 ? `<s>${this.fmt(t.list)}</s> ` : ''}${this.fmt(t.pay)}`;
      return `<button type="button" class="bb-atc-btn" data-bb="atc" ${dis ? 'disabled' : ''}>${label}</button>
      ${this.trustHTML()}`;
    }
    trustHTML() {
      /* Badge 1 follows the session market: the free-shipping threshold is US-only, so non-US
         visitors get the duties promise instead, which is verified DDP on every lane
         (ethetic/site/shipping-promise.md). */
      /* Every badge is two lines, broken explicitly so all three match at any width. */
      const shipLabel = sessionCountry() === 'US'
        ? ['Free U.S Shipping', 'over $100']
        : ['No Duties or', 'Import Fees'];
      const badges = [shipLabel, ['Museum-Grade', 'Quality'], ['Made in the', 'USA']];
      return `<div class="bb-trust">${badges.map((l, i) => `
        <div class="bb-trust-i">${TRUST_ICONS[i] || ''}<span class="bb-trust-l">${l[0]}<br>${l[1]}</span></div>`).join('')}
      </div>`;
    }
    updateAtc() {
      const wrap = this.querySelector('.bb-atc');
      if (!wrap) return;
      wrap.innerHTML = this.atcHTML();
      const atc = wrap.querySelector('[data-bb="atc"]');
      if (atc) atc.onclick = () => this.addToCart();
    }
    customFieldsHTML(key, product) {
      const fields = customFieldsFor(product);
      if (!fields) return '';
      const vals = this.state.custom[key] || {};
      const fieldsHTML = `<div class="bb-cf">${fields.map(f => `
        <div><span class="bb-optlab">${f}</span>
        <input type="text" class="bb-cfin" data-cf="${key}" data-cf-field="${f.replace(/"/g, '&quot;')}" placeholder="${f}" maxlength="60" value="${(vals[f] || '').replace(/"/g, '&quot;')}"></div>`).join('')}
      </div>`;
      let imgHTML = '';
      if (customImgFor(product)) {
        const file = this.state.customFile[key];
        imgHTML = `<div style="margin-top:10px">
          <span class="bb-optlab">Add Image <span style="font-weight:400;color:#8a8781">(optional)</span></span>
          ${file
            ? `<div style="display:flex;align-items:center;gap:8px;padding:10px 12px;border:1.5px solid #e3e1dd;border-radius:8px;background:#fff;font-size:12.5px"><span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${file.name.replace(/</g, '&lt;')}</span><button type="button" data-cfimg-clear="${key}" style="all:unset;cursor:pointer;width:22px;height:22px;border-radius:50%;background:#111;color:#fff;font-size:12px;display:flex;align-items:center;justify-content:center;flex:0 0 auto">×</button></div>`
            : `<label style="display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 12px;border:1.5px dashed #c9c6c0;border-radius:8px;background:#fff;font-size:12.5px;font-weight:700;color:#111;cursor:pointer">+ Upload Image<input type="file" accept="image/*" data-cfimg="${key}" style="display:none"></label>`}
        </div>`;
      }
      return fieldsHTML + imgHTML;
    }
    render() {
      if (this._portal) { this._portal.remove(); this._portal = null; }
      const s = this.state, c = this.cfg, multi = s.pack.paid > 1;
      const ref = this.refProduct();
      const unitP = ref ? this.priceOf(ref, s.sizeValue, s.frameValue) : null;
      const unitC = ref ? this.compareOf(ref, s.sizeValue, s.frameValue) : null;
      let priceHTML = '';
      if (unitP != null) {
        const nPaid = this.paidCount();
        const t = this.totals();
        const listTotal = t.ok ? t.list : unitC * nPaid;
        const payTotal = t.ok ? t.pay : Math.round(unitP * (1 - this.offNow())) * nPaid;
        const save = listTotal - payTotal;
        if (save > 0) {
          priceHTML = `<div class="bb-price" style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;font-size:18px;font-weight:800;color:#111;margin:2px 0 6px;line-height:1.2"><span><span style="font-weight:600;font-size:14px;margin-right:4px">From</span><s style="color:#8a8781;font-weight:400;font-size:14px;margin-right:8px">${this.fmt(listTotal)}</s>${this.fmt(payTotal)}</span><span style="background:#d92c20;color:#fff;font-size:11px;font-weight:800;padding:3px 8px;border-radius:4px;letter-spacing:.03em;white-space:nowrap">SAVE ${this.fmt(save)}</span></div>`;
        } else {
          priceHTML = `<div class="bb-price" style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;font-size:18px;font-weight:800;color:#111;margin:2px 0 6px;line-height:1.2"><span>${this.fmt(unitP)}</span></div>`;
        }
      }
      const curPrice = unitP != null ? (this.offNow() ? this.fmt(Math.round(unitP * (1 - this.offNow()))) : this.fmt(unitP)) : '';
      /* Sep 18 2026: the pack row is Step 1 whenever the selector is on, so every later step
         shifts by one. With the selector off, packOffset is 0 and numbering is unchanged. */
      const packsShown = (c.packs || []).length > 1;
      const packOffset = packsShown ? 1 : 0;
      const packsBlock = packsShown
        ? this.stepH(1, 'Choose Your Pack') + `<div class="bb-packs" style="grid-template-columns:repeat(${c.packs.length},1fr)">${c.packs.map(p => {
            const off = p.off ? `<span class="bb-off">SAVE ${Math.round(p.off * 100)}%</span>` : '';
            return `<button type="button" class="bb-pack ${s.pack.id === p.id ? 'active' : ''}" data-pack="${p.id}">${off}<span class="bb-pack-name">${p.label}</span></button>`;
          }).join('')}</div>`
        : '';
      const singleCustom = !multi && isCustom(s.paid[0]) ? this.stepH(packOffset + 1, 'Personalize Your Print') + this.customFieldsHTML('paid:0', s.paid[0]) : '';
      const stepBase = packOffset + (singleCustom ? 2 : 1);
      const frameStep = stepBase + 1;
      this.querySelector('[data-bb-root]').innerHTML = `
        ${priceHTML}
        ${this.tiersHTML()}
        <div class="bb-card">
        ${packsBlock}
        ${multi ? this.stepH(packOffset + 1, 'Choose Your Prints', this.filledCount() + '/' + s.paid.length + ' added') + `<div class="bb-slots">${this.slotsHTML()}</div>` : singleCustom}
        ${multi ? '' : this.stepH(stepBase, 'Choose Your Size') + `
        <div class="bb-sizedd ${s.sizeOpenKey === 'step2' ? 'open' : ''}" data-bb="sizedd">
          <button type="button" class="bb-sizedd-btn" data-bb="size-toggle">
            <span>${dispSizeCm(s.sizeValue)}</span>
            <span class="bb-sizedd-price">${curPrice}</span>
            <span class="bb-caret">▾</span>
          </button>
          <div class="bb-sizedd-list">${c.sizes.map(z => {
            const pr = ref ? this.priceOf(ref, z, s.frameValue) : null;
            const cm = ref ? this.compareOf(ref, z, s.frameValue) : null;
            if (pr == null) return '';
            const eff = this.offNow() ? Math.round(pr * (1 - this.offNow())) : pr;
            const rowPrice = (cm && cm > eff) ? `<s>${this.fmt(cm)}</s> ${this.fmt(eff)}` : this.fmt(eff);
            return `<button type="button" class="bb-sizedd-row ${z === s.sizeValue ? 'sel' : ''}" data-size="${z.replace(/"/g, '&quot;')}">
              <span>${dispSizeCm(z)}${popBadge(z)}</span>
              <span class="bb-sizedd-rowprice">${rowPrice}</span>
            </button>`;
          }).join('')}</div>
        </div>`}
        ${multi ? '' : this.stepH(frameStep, 'Choose Your Frame') + `<div class="bb-frames">${c.frames.map(f => {
          const img = this.frameImg(f);
          const chipInner = img ? `<img src="${img}" alt="${f}" loading="lazy">` : '<span></span>';
          return `
          <button type="button" class="bb-frame ${f === s.frameValue ? 'active' : ''}" data-frame="${f}">
            ${/black/i.test(f) ? '<span class="bb-pop">POPULAR</span>' : ''}
            <span class="bb-chip" data-f="${f.toLowerCase().replace(/[^a-z]/g, '')}">${chipInner}</span>
            <span class="bb-frame-label">${f}</span>
          </button>`;
        }).join('')}
        </div>`}
        </div>
        <div class="bb-atc">${this.atcHTML()}</div>
        ${this.pickerHTML()}`;
      this.bind();
      if (s.pickTarget) {
        const row = (this._portal || this).querySelector('.bb-collrow');
        const act = (this._portal || this).querySelector('.bb-coll.active');
        centerH(row, act);
      }
    }
    stepH(n, title, hint) {
      return `<div class="bb-step-h"><span class="bb-n">${n}</span><h3>${title}</h3>${hint ? `<span class="bb-hint">${hint}</span>` : ''}</div>`;
    }
    filledCount() { return this.state.paid.filter(Boolean).length; }
    slotsHTML() {
      const s = this.state;
      const paidHTML = s.paid.map((p, i) => {
        if (!p) return `<div class="bb-slot bb-empty" data-pick="paid:${i}"><div class="bb-art">+</div><div class="bb-body"><div class="bb-t">Empty Slot</div><div class="bb-s">Tap to add print</div></div>${s.pack.expandable && s.paid.length > s.pack.paid ? `<button type="button" class="bb-remove" data-remove="paid:${i}">×</button>` : ''}</div>`;
        const rs = this.sizeFor(p, this.sizeAt(i));
        const fr = this.frameAt(i);
        const pr = this.priceOf(p, this.sizeAt(i), fr);
        const cm = this.compareOf(p, this.sizeAt(i), fr);
        const pay = pr != null ? Math.round(pr * (1 - this.offNow())) : null;
        const slotKey = 'paid:' + i;
        const frameKey = 'frame:' + slotKey;
        const optsCtl = s.pack.paid > 1
          ? `<div class="bb-slotopts">
              <div class="bb-slotopt">
                <span class="bb-slotopt-l">Size</span>
                <div class="bb-sizedd bb-slotsize ${s.sizeOpenKey === slotKey ? 'open' : ''}" data-slot-size="${slotKey}">
                  <button type="button" class="bb-sizedd-btn" data-slot-size-toggle="${slotKey}">
                    <span>${dispSize(rs)}</span>
                    <span class="bb-caret">▾</span>
                  </button>
                  <div class="bb-sizedd-list">${this.sizesOf(p).map(z => {
                    const zpr = this.priceOf(p, z, fr);
                    const zcm = this.compareOf(p, z, fr);
                    if (zpr == null) return '';
                    const zeff = this.offNow() ? Math.round(zpr * (1 - this.offNow())) : zpr;
                    const zRowPrice = (zcm && zcm > zeff) ? `<s>${this.fmt(zcm)}</s> ${this.fmt(zeff)}` : this.fmt(zeff);
                    return `<button type="button" class="bb-sizedd-row ${normStr(z) === normStr(rs) ? 'sel' : ''}" data-slot-size-row="${slotKey}" data-slot-size-val="${z.replace(/"/g, '&quot;')}">
                      <span>${dispSizeCm(z)}</span>
                      <span class="bb-sizedd-rowprice">${zRowPrice}</span>
                    </button>`;
                  }).join('')}</div>
                </div>
              </div>
              <div class="bb-slotopt">
                <span class="bb-slotopt-l">Framing</span>
                <div class="bb-sizedd bb-slotframe ${s.sizeOpenKey === frameKey ? 'open' : ''}" data-slot-frame="${slotKey}">
                  <button type="button" class="bb-sizedd-btn" data-slot-frame-toggle="${slotKey}">
                    <span>${fr}</span>
                    <span class="bb-caret">▾</span>
                  </button>
                  <div class="bb-sizedd-list">${this.cfg.frames.map(f => {
                    return `<button type="button" class="bb-sizedd-row ${normStr(f) === normStr(fr) ? 'sel' : ''}" data-slot-frame-row="${slotKey}" data-slot-frame-val="${f.replace(/"/g, '&quot;')}">
                      <span>${f}</span>
                    </button>`;
                  }).join('')}</div>
                </div>
              </div>
            </div>`
          : `<div class="bb-s">${dispSizeCm(rs)} · ${fr}</div>`;
        const custom = isCustom(p) ? this.customFieldsHTML('paid:' + i, p) : '';
        return `<div class="bb-slot ${custom ? 'bb-slot-col' : ''}">
          <button type="button" class="bb-remove" data-remove="paid:${i}">×</button>
          <div class="bb-slot-row">
            <div class="bb-art" data-pick="paid:${i}">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</div>
            <div class="bb-body">
              <div class="bb-thead">
                <div class="bb-t">${p.title}</div>
                <div class="bb-p">${pay != null ? ((cm && cm > pay) ? `<s>${this.fmt(cm)}</s> ` : '') + this.fmt(pay) : '—'}</div>
              </div>
              ${optsCtl}
            </div>
          </div>
          ${custom}
        </div>`;
      }).join('');
      const addMore = (s.pack.expandable && s.paid.length < 10)
        ? `<div class="bb-slot bb-empty bb-addmore" data-bb="add-slot">+ Add Another Print — 20% OFF</div>`
        : '';
      return paidHTML + addMore;
    }
    pickerHTML() {
      const c = this.cfg, s = this.state;
      const colls = this.sliderColls || [];
      let list = c.catalog.filter(p => !s.filter || collsOf(p).includes(s.filter));
      return `<div class="bb-picker ${s.pickTarget ? 'open' : ''}" data-bb="picker">
        <div class="bb-sheet">
          <div class="bb-picker-head" style="display:flex;align-items:center;justify-content:space-between">
            <h4>Choose Your Print</h4>
            <button type="button" class="bb-picker-done" data-bb="picker-close" style="margin-left:auto;background:#111;color:#fff;border:0;border-radius:999px;padding:9px 20px;font-size:13px;font-weight:800;line-height:1;cursor:pointer;display:inline-flex;align-items:center;justify-content:center">Done</button>
          </div>
          <div class="bb-collrow">${colls.map(x => `
            <button type="button" class="bb-coll ${x.title === s.filter ? 'active' : ''}" data-coll="${x.title.replace(/"/g, '&quot;')}">
              <span class="bb-coll-img">${x.img ? `<img src="${x.img}" alt="" loading="lazy">` : ''}</span>
              <span class="bb-coll-name">${x.label}</span>
            </button>`).join('')}
          </div>
          <div class="bb-picker-grid">${list.length ? list.map(p => `
            <div class="bb-pick-card">
              <div class="bb-pick-art">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</div>
              <div class="bb-pick-t">${p.title}</div>
              <button type="button" data-add="${p.id}">+ Add</button>
            </div>`).join('') : '<div class="bb-picker-empty">No prints found in this collection</div>'}
          </div>
        </div>
      </div>`;
    }
    bind() {
      const s = this.state, c = this.cfg;
      this.querySelectorAll('[data-pack]').forEach(b => b.onclick = () => this.setPack(c.packs.find(p => p.id === b.dataset.pack)));
      const st = this.querySelector('[data-bb="size-toggle"]'); if (st) st.onclick = () => { s.sizeOpenKey = s.sizeOpenKey === 'step2' ? null : 'step2'; this.render(); };
      this.querySelectorAll('[data-size]').forEach(b => b.onclick = () => { s.sizeValue = b.dataset.size; s.sizeBy = {}; s.sizeOpenKey = null; this.render(); });
      this.querySelectorAll('[data-slot-size-toggle]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        const k = b.dataset.slotSizeToggle;
        s.sizeOpenKey = s.sizeOpenKey === k ? null : k;
        this.render();
      });
      this.querySelectorAll('[data-slot-size-row]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        s.sizeBy[b.dataset.slotSizeRow] = b.dataset.slotSizeVal;
        s.sizeOpenKey = null;
        this.render();
      });
      this.querySelectorAll('[data-slot-frame-toggle]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        const k = 'frame:' + b.dataset.slotFrameToggle;
        s.sizeOpenKey = s.sizeOpenKey === k ? null : k;
        this.render();
      });
      this.querySelectorAll('[data-slot-frame-row]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        s.frameBy[b.dataset.slotFrameRow] = b.dataset.slotFrameVal;
        s.sizeOpenKey = null;
        this.render();
      });
      this.querySelectorAll('[data-frame]').forEach(b => b.onclick = () => { s.frameValue = b.dataset.frame; s.frameBy = {}; this.render(); });
      this.querySelectorAll('[data-pick]').forEach(el => el.onclick = () => { s.pickTarget = el.dataset.pick; this.render(); });
      const addSlot = this.querySelector('[data-bb="add-slot"]');
      if (addSlot) addSlot.onclick = () => { if (s.paid.length < 10) { s.paid.push(this.cfg.packsEnabled ? (this.cfg.currentProduct || null) : null); this.render(); } };
      this.querySelectorAll('[data-remove]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        const idx = +b.dataset.remove.split(':')[1];
        if (s.pack.expandable && s.paid.length > s.pack.paid) {
          s.paid.splice(idx, 1);
          s.custom = shiftKeys(s.custom, 'paid', idx);
          s.customFile = shiftKeys(s.customFile, 'paid', idx);
          s.sizeBy = shiftKeys(s.sizeBy, 'paid', idx);
          s.frameBy = shiftKeys(s.frameBy, 'paid', idx);
        } else {
          s.paid[idx] = null;
          delete s.custom['paid:' + idx];
          delete s.customFile['paid:' + idx];
          delete s.sizeBy['paid:' + idx];
          delete s.frameBy['paid:' + idx];
        }
        this.render();
      });
      this.querySelectorAll('[data-cf]').forEach(inp => inp.oninput = e => {
        const key = e.target.dataset.cf, field = e.target.dataset.cfField;
        if (!s.custom[key]) s.custom[key] = {};
        s.custom[key][field] = e.target.value;
        this.updateAtc();
      });
      this.querySelectorAll('[data-cfimg]').forEach(inp => inp.onchange = e => {
        const f = e.target.files && e.target.files[0];
        if (f) {
          if (f.size > 10 * 1024 * 1024) { alert('Image must be under 10MB'); e.target.value = ''; return; }
          s.customFile[e.target.dataset.cfimg] = f;
        }
        this.render();
      });
      this.querySelectorAll('[data-cfimg-clear]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        delete s.customFile[b.dataset.cfimgClear];
        this.render();
      });
      const picker = this.querySelector('[data-bb="picker"]');
      if (picker) {
        picker.querySelectorAll('[data-coll]').forEach(b => b.onclick = () => { s.filter = b.dataset.coll; this.render(); });
        picker.querySelectorAll('[data-add]').forEach(b => b.onclick = () => {
          const p = c.catalog.find(x => String(x.id) === b.dataset.add);
          const parts = s.pickTarget.split(':');
          s.paid[+parts[1]] = p;
          delete s.custom[s.pickTarget];
          delete s.customFile[s.pickTarget];
          if (isCustom(p)) s.custom[s.pickTarget] = {};
          s.pickTarget = null; this.render();
        });
        const close = picker.querySelector('[data-bb="picker-close"]'); if (close) close.onclick = () => { s.pickTarget = null; this.render(); };
        picker.onclick = e => { if (e.target === picker) { s.pickTarget = null; this.render(); } };
        document.body.appendChild(picker);
        this._portal = picker;
      }
      const atc = this.querySelector('[data-bb="atc"]'); if (atc) atc.onclick = () => this.addToCart();
    }
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('ethetic-bundle-builder').forEach(el => {
      if (el.state && el.state.sizeOpenKey && !e.target.closest('[data-bb="sizedd"]') && !e.target.closest('[data-slot-size]') && !e.target.closest('[data-slot-frame]')) { el.state.sizeOpenKey = null; el.render(); }
    });
  });
  if (!customElements.get('ethetic-bundle-builder')) customElements.define('ethetic-bundle-builder', EtheticBundleBuilder);
})();
